var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLockFilled = function SvgIconLockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.499c-1.322 0-2.545.666-3.417 1.77-.772.976-1.207 2.081-1.312 4.056H5c-1.105 0-2 .906-2 2.025v10.124c0 1.118.895 2.025 2 2.025h14c1.105 0 2-.907 2-2.025V10.35c0-1.119-.895-2.025-2-2.025h-2.27c-.105-1.975-.54-3.08-1.312-4.057C14.546 3.165 13.323 2.5 12 2.5m3.219 5.826c-.1-1.695-.466-2.453-.98-3.103C13.612 4.427 12.8 4.026 12 4.026s-1.61.401-2.24 1.196c-.512.65-.878 1.408-.978 3.103zm-2.515 6.959c.385-.222.645-.642.645-1.123 0-.713-.57-1.291-1.275-1.291h-.027a1.284 1.284 0 0 0-1.248 1.29c0 .475.253.89.63 1.114v2.114c0 .356.285.645.637.645a.64.64 0 0 0 .638-.645z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLockFilled;